/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Editor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromImageeditor from 'Logic/ImageEditor.js'
import ImageEditor from 'DesignSystem/ImageEditor/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Editor({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Edit/EditModal/Content/Editor"
  
}) {
let imageCardResourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'image_card',
path: 'resource.preview_url',
})
let patientImageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'patient_image',
path: 'slot_key',
format: fromImageeditor.getAspectRatio,
})
let patientImageSlotKeyValueData1 = fromData.useDataFormat({ viewPath,
context: 'patient_image',
path: 'slot_key',
format: fromImageeditor.getWillRenderCanvas,
})
let onSave = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ImageEditor
  viewPath={`${viewPath}/ImageEditor`}
 data="image_card.resource.preview_url"
 src={imageCardResourcePreviewUrlValueData}
 data="patient_image.slot_key"
 format="/Logic/ImageEditor.js getAspectRatio"
 aspectRatio={patientImageSlotKeyValueData}
 data="patient_image.slot_key"
 format="/Logic/ImageEditor.js getWillRenderCanvas"
 willRenderCanvas={patientImageSlotKeyValueData1}
 limitToImage={false}
 onSave={onSave}
/>
{children}
</React.Fragment>)
}